import React from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import { SkillBuilderJob } from '../data/api';
import messages from '../messages';

interface JobStatusProps {
  job: SkillBuilderJob | null;
  error: boolean;
  onCancel?: () => void;
  onRetry?: () => void;
  isRetrying?: boolean;
}

const JobStatus: React.FC<JobStatusProps> = ({
  job, error, onCancel, onRetry, isRetrying = false,
}) => {
  const intl = useIntl();
  if (error) {
    return <div className="alert alert-danger" role="alert">{intl.formatMessage(messages.jobPollError)}</div>;
  }
  if (!job) { return null; }

  const isRunning = job.status === 'queued' || job.status === 'running' || job.status === 'cancel_requested';
  return (
    <div className={`ai-assisted-course-authoring-tab__job-status ai-assisted-course-authoring-tab__job-status--${job.status}`} aria-live="polite">
      {isRunning && <span className="spinner-border ai-assisted-course-authoring-tab__spinner" role="status" aria-hidden="true" />}
      <div>
        <strong>{intl.formatMessage(messages.jobStatusLabel, { status: job.status })}</strong>
        {job.progress && <p>{job.progress}</p>}
        {job.error && <p className="ai-assisted-course-authoring-tab__job-error">{job.error}</p>}
      </div>
      {onCancel && isRunning && (
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onCancel}>
          {intl.formatMessage(messages.cancelButton)}
        </button>
      )}
      {onRetry && job.status === 'failed' && (
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={onRetry} disabled={isRetrying}>
          {intl.formatMessage(messages.retryButton)}
        </button>
      )}
    </div>
  );
};

export default JobStatus;
